import React from 'react';
import { Language, View } from '../types';
import HeroSection from '../components/home/HeroSection';
import AboutTeaser from '../components/home/AboutTeaser';
import HowIHelpTeaser from '../components/home/HowIHelpTeaser';
import TestimonialsSection from '../components/home/TestimonialsSection';
import PhilosophySection from '../components/home/PhilosophySection';
import ContactSection from '../components/home/ContactSection';
import Footer from '../components/layout/Footer';

interface HomePageProps {
  lang: Language;
  setView: (v: View) => void;
}

const HomePage: React.FC<HomePageProps> = ({ lang, setView }) => {
  return (
    <>
      <HeroSection lang={lang} setView={setView} />
      <AboutTeaser lang={lang} setView={setView} />
      <HowIHelpTeaser lang={lang} setView={setView} />
      <TestimonialsSection lang={lang} />
      <PhilosophySection lang={lang} setView={setView} />
      <ContactSection lang={lang} />
      <Footer lang={lang} setView={setView} />
    </>
  );
};

export default HomePage;
